import { ContentChildren, Directive, input, Input } from "@angular/core";

@Directive({
    selector: 'cec-result-summary>cec-result-item',
    standalone: true
})
export class ResultItemDirective {

    /** Result item label reference */
    public labelKey = input('');

    /** Result item price reference */
    public value = input<number | null>(null);

    /** Result item price reference */
    public postfix = input('points');

    /** Flag for hiding the postfix */
    public hidePostfix = input(true);

    /** Result item type reference */
    public type = input<'default' | 'total'>('default');
}